import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useDocuments } from '../../hooks/useDocuments';
import DocumentsDashboard from '../../components/administracion/DocumentsDashboard';

const DocumentosPage = () => {
  const { documents, error, isLoading } = useDocuments();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">Error al cargar documentos.</Alert>;

  return (
    <Box sx={{ p: 2 }}>
      <DocumentsDashboard
        windows={documents}
        onReorder={(newOrder) => {
          console.log('Nuevo orden de documentos:', newOrder);
        }}
      />
    </Box>
  );
};

export default DocumentosPage;